// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"frame_wrapper_2wdlr","container":"frame_container_3Glv0"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/frame/frame.scss
// module id = 1572
// module chunks = 0